export const MINIMUM_VALUES_FOR_SEARCH = 10;
export const SEPARATOR = '|';

export const InputTypesEnum = {
  ASYNC_SELECT: 'ASYNC_SELECT',
  BOOLEAN: 'BOOLEAN',
  CURRENCY: 'CURRENCY',
  INPUT_WITH_TAGS: 'INPUT_WITH_TAGS',
  NESTED_INPUT_TYPE: 'NESTED_INPUT_TYPE',
  NUMBER_INPUT: 'NUMBER_INPUT',
  SELECT: 'SELECT',
} as const;
export type InputTypesEnum =
  (typeof InputTypesEnum)[keyof typeof InputTypesEnum];

export const NUMBER_INPUTS = [
  InputTypesEnum.CURRENCY,
  InputTypesEnum.NUMBER_INPUT,
] as const;
export const STRING_INPUTS = [
  InputTypesEnum.ASYNC_SELECT,
  InputTypesEnum.INPUT_WITH_TAGS,
  InputTypesEnum.NESTED_INPUT_TYPE,
  InputTypesEnum.SELECT,
] as const;

export const InputNamesEnum = {
  END_VALUE: 'endValue',
  KEYS: 'keys',
  NUMBER_VALUE: 'number',
  OPERATOR: 'operator',
  START_VALUE: 'startValue',
  VALUES: 'values',
} as const;
export type InputNamesEnum =
  (typeof InputNamesEnum)[keyof typeof InputNamesEnum];

export const QUICK_FILTER_LIST_LIMITS = {
  DEFAULT: 10,
  BUFFER: 2,
};

export const MODULE_FILTER_EXCLUSIONS: Record<
  'payments' | 'observability',
  string[]
> = {
  payments: [
    '3ds_error_code',
    '3ds_transaction_status',
    '3ds_transaction_status_reason',
    'initiated_transaction_type',
  ],
  observability: ['search'],
};
